import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import { gql } from '@apollo/client';
export var GET_PIMCORE_ASSET_HOST = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    query storeConfigData {\n        storeConfig {\n            id\n            store_code\n            pimcore_assets_host\n        }\n    }\n"])));
export default {
  getPimcoreAssetHost: GET_PIMCORE_ASSET_HOST
};